import { CJPromoShelf } from '@inkitt/types-galatea';
import { languageCodesSchema } from '@inkitt/types-galateatv';
import { z } from 'zod';
import { c } from '../../contract';

export const promoShelfRouter = c.router(
  {
    update: {
      description: 'Update the CJ promotional shelf in Galatea',
      method: 'POST',
      path: '/update',
      body: c.noBody(),
      responses: {
        200: z.object({
          message: z.string(),
        }),
      },
    },
    getShelf: {
      description: 'Get the CJ promo shelf',
      method: 'GET',
      path: '/shelf',
      query: z.object({
        language: languageCodesSchema.describe('Language code for the shelf'),
      }),
      responses: {
        200: CJPromoShelf,
      },
    },
  },
  { pathPrefix: '/galatea-promo-shelf' },
);
